import { AttributeTypeValue, ProfileAttribute, profileAttributeSchema } from "@bonusmap/api-types";
import { ProfileBaseComponent } from "./profile-base-component";
import { isBoolean, isDate, isNumber } from "@bonusmap/shared_ui/library";

export class ProfileAttributeValue extends ProfileBaseComponent {
    static webComponentName: string = "profile-attribute-value";
    static observedAttributes = [];
    protected _templateId: string = "profile-attribute-value";
    private get inputElement(): HTMLInputElement | null {
        return this.roleElementSelector("input") as HTMLInputElement | null;
    };
    private _value!: number | Date | boolean;
    public get value(): number | Date | boolean {
        return this._value;
    }
    public set value(value: number | Date | boolean) {
        this._value = this.convertValue(value);
    }
    isValidValue(value: any): boolean {
        if (this.type_value === 'number') {
            return isNumber(value);
        }
        else if (this.type_value === 'date') {
            return isDate(value);
        }
        else if (this.type_value === 'boolean') {
            return isBoolean(value);
        }
        return false;
    }
    convertValue(value: any): number | Date | boolean | null {
        if (this.type_value === 'number') {
            const num = Number(value);
            return isNaN(num) ? null : num;
        }
        else if (this.type_value === 'date') {
            const date = new Date(value);
            return isNaN(date.getTime()) ? null : date;
        }
        else if (this.type_value === 'boolean') {
            if (value === 'true' || value === true) return true;
            if (value === 'false' || value === false) return false;
            return null;
        }
        return null;
    }

    private _type_value!: AttributeTypeValue;
    public get type_value(): AttributeTypeValue {
        return this._type_value;
    }
    public set type_value(value: AttributeTypeValue) {
        this._type_value = value;
        this.render();
        this.classList.toggle('d-none', !this.type_value);
    }
    protected buildRenderingData(): Record<string, any> {
        console.log("buildRenderingData", this.type_value, this.value, this.readOnly);
        return {
            componentId: this.componentId,
            value: this.value,
            type_value: this.type_value,
            readOnly: this.readOnly
        };
    }
    private _componentId!: string;
    public get componentId(): string {
        if (!this._componentId) {
            this._componentId = `${this.createRandomId()}`;
        }
        return this._componentId;
    }
    resetDataValue(): void {
        // rimuove data-value attribute
        this._value = null;
        this.removeAttribute('data-value');
    }
    private checkForIndeterminate(): void {
        if(this.inputElement && this.inputElement.type === 'checkbox' && !isBoolean(this.value)) {
                console.log("Imposto indeterminate",this.value);
                this.inputElement.indeterminate = true;
        }
    }
    afterRender(): void {
        if (this.inputElement) {
            this.inputElement.addEventListener('change', (event: any) => {
                const newValue = this.inputElement.type === 'checkbox' ? this.inputElement.checked : this.inputElement.value;
                this._value = this.convertValue(newValue);
                this.dispatch('value-changed', { value: this._value });
            });
        }
        const dataValue = this.getAttribute('data-value');
        if (dataValue !== null && dataValue !== undefined) {
            if (this.isValidValue(this.convertValue(dataValue))) {
                this.value = this.convertValue(dataValue);
                // Aggiorna l'inputElement se esiste
                if (this.inputElement) {
                    if (this.type_value === 'boolean' && typeof this.value === 'boolean') {
                        this.inputElement.checked = this.value;
                    } else if (this.type_value === 'date' && this.value instanceof Date) {
                        this.inputElement.value = this.value.toISOString().split('T')[0];
                    } else if (this.type_value === 'number' && typeof this.value === 'number') {
                        this.inputElement.value = this.value.toString();
                    }
                }
                else {
                    let displayValue = '';
                    if (this.type_value === 'date' && this.value instanceof Date) {
                        displayValue = this.value.toLocaleDateString();
                    }
                    else if (this.type_value === 'boolean' && typeof this.value === 'boolean') {
                        displayValue = this.value ? 'Sì' : 'No';
                    }
                    else if (this.type_value === 'number' && typeof this.value === 'number') {
                        displayValue = this.value.toLocaleString();
                    }
                    else {
                        displayValue = `${this.value}`;
                    }
                    this.roleElementSelector('value')!.innerHTML = `${displayValue}`;
                }
                // Emette l'evento per comunicare il valore iniziale al componente padre
                this.dispatch('value-changed', { value: this._value });
            }
            else {
             console.log(`Valore non valido per il tipo ${this.type_value}:`, dataValue);
            }
        }
        this.checkForIndeterminate();
    }
    protected render(): void {
        this.innerHTML = '';
        this.classList.add('d-none');
        if (!this.type_value) return;
        super.render();
    }

}